/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup'
import { VALIDATION_KEYS } from '../../../utils/translation-constants'
import validationConfig from "custom/config/validation.config.json";
const suggestionsConfig = validationConfig["OtherService"]["suggestions"];

const validateCategory = suggestionsConfig["isFeedbackCategoryRequired"]
  ? {
    category: Yup.string().required(VALIDATION_KEYS.FEEDBACK_CATEGORY_REQUIRED),
    }
  : {
      category: Yup.string().optional(),
    };

const validateSuggestion = suggestionsConfig["isSuggestionRequired"]
  ? {
    suggestion: Yup.string()
    .min(10, VALIDATION_KEYS.FEEDBACK_MIN_MAX)
    .max(1000, VALIDATION_KEYS.FEEDBACK_MIN_MAX)
    .required(VALIDATION_KEYS.FEEDBACK_REQUIRED),
    }
  : {
      suggestion: Yup.string().optional(),
    };


export const SuggestionSchema = Yup.object().shape({
 ...validateSuggestion,
  ...validateCategory,
})

export const ServiceRequestSchema = Yup.object().shape({
  suggestion: Yup.string()
    .min(1, "Please enter suggestion")
    .required("Suggestion is required"),
  category: Yup.string().required("Category is required"),
});
